import * as React from 'react';
import { GdsAggregationServiceGroup } from '../../../../../Checkout/types';
import { SeatSelection } from '../../../../../Icons';
import { SelectedSeatsServiceType } from '../../../../../Checkout/store/selectedServices/reducers';
import Service from '../Service';
import { ServiceType } from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/types';
import { useServicePageProps } from '../../../../../CheckoutAdditionalService/components/hooks';
import ServiceCardDialog from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/components/ServiceCardDialog/ServiceCardDialog';
import ServicePage from '../../../../../Checkout/components/Checkout/ServicePage/ServicePage';
import { useTranslation } from 'react-i18next';

interface Props {
	services: GdsAggregationServiceGroup;
}

const Seat: React.FC<Props> = services => {
	const seats: string[] = [];

	services.services.selectedServices.forEach(service => {
		seats.push((service.service as SelectedSeatsServiceType).number);
	});

	const servicePageProps = useServicePageProps();

	const open = () => servicePageProps.toggleModal(ServiceType.Seats);

	const { t } = useTranslation('FlightInfoCard');

	return (
		<>
			<Service icon={SeatSelection} selected={seats.length > 0} onClick={open}>
				{seats.length > 0 ? (
					<span>
						{t('Seats')}: {seats.join(',')}
					</span>
				) : (
					<span>{t('Choose comfortable seats')}</span>
				)}
			</Service>

			<ServicePage>
				{childrenProps => (
					<ServiceCardDialog
						order={servicePageProps.order}
						openedModal={servicePageProps.openedModal}
						onClose={servicePageProps.toggleModal.bind(null, null)}
						passengers={servicePageProps.passengers}
						passengerLabels={servicePageProps.passengerLabels}
						{...childrenProps}
					/>
				)}
			</ServicePage>
		</>
	);
};

export default Seat;
